import { render, staticRenderFns } from "./Captionedimage.vue?vue&type=template&id=5e482893&scoped=true&"
import script from "./Captionedimage.vue?vue&type=script&lang=js&"
export * from "./Captionedimage.vue?vue&type=script&lang=js&"
import style0 from "./Captionedimage.vue?vue&type=style&index=0&id=5e482893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e482893",
  null
  
)

export default component.exports